import cn from 'classnames'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getQBRFormattedFinance } from 'partner360/components/QBR/helpers/getQBRFormattedFinance'
import { selectRounding } from 'partner360/features/QBR'

import styles from './Incremental.module.scss'

interface IIncrementalProps {
  value?: number
}

export const Incremental: FC<IIncrementalProps> = ({ value = 0 }) => {
  const rounding = useSelector(selectRounding)

  const isPositive = value > 0
  const isNegative = value < 0

  const formattedValue = useMemo(() => {
    return getQBRFormattedFinance(value, rounding)
  }, [value, rounding])

  return (
    <div
      className={cn(styles.root, {
        [styles.positive]: isPositive,
        [styles.negative]: isNegative,
      })}
    >
      <span>{isPositive && '+'}</span>
      <span>{formattedValue}</span>
    </div>
  )
}
